import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({
  theme: "light",
  setTheme: () => {}
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved && ["light", "dark", "green"].includes(saved) ? saved : "light";
  });

  const setTheme = (newTheme) => {
    if (["light", "dark", "green"].includes(newTheme)) {
      setThemeState(newTheme);
      localStorage.setItem("theme", newTheme);
    }
  };

  useEffect(() => {
    const root = document.documentElement;
    // Remove previous classes
    root.classList.remove("theme-light", "theme-dark", "theme-green");
    // Add new class
    root.classList.add(`theme-${theme}`);
    
    // Toggle standard dark selector class
    if (theme !== "light") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
